import {
  useCallback,
  createContext,
  FC,
  useMemo,
  useReducer,
  ReactNode,
} from "react";
import {
  BookingQuoteContextType,
  BookingQuoteActionType,
  BookingQuoteActions,
} from "./types";

export const BookingQuoteContext = createContext<
  BookingQuoteContextType | undefined
>(undefined);

BookingQuoteContext.displayName = "BookingContext";

const initialState = {
  quote: {},
};

const bookingQuoteReducer = (
  state: typeof initialState,
  action: BookingQuoteActionType
) => {
  switch (action.type) {
    case BookingQuoteActions.setQuote: {
      const compoundQuotes = { ...state.quote, ...action.value };
      return { ...state, quote: compoundQuotes };
    }
    case BookingQuoteActions.reset: {
      return initialState;
    }
  }
};

interface BookingQuoteContextProviderProps {
  children: ReactNode;
}

const BookingQuoteContextProvider: FC<BookingQuoteContextProviderProps> = ({
  children,
}) => {
  const [bookingQuoteState, dispatch] = useReducer(
    bookingQuoteReducer,
    initialState
  );

  const setQuote = useCallback((value: {}) => {
    dispatch({ value, type: BookingQuoteActions.setQuote });
  }, []);

  const reset = useCallback(() => {
    dispatch({ type: BookingQuoteActions.reset });
  }, []);

  const value = useMemo(
    () => ({
      ...bookingQuoteState,
      setQuote,
      reset,
    }),
    [bookingQuoteState, setQuote, reset]
  );

  return (
    <BookingQuoteContext.Provider value={value}>
      {children}
    </BookingQuoteContext.Provider>
  );
};

export { BookingQuoteContextProvider };
